<div class="alert-box">
  <div class="modal-header">
    <h4 class="modal-title">{{data?.title || 'Info'}}</h4>
    <button type="button"
      class="ml-auto flex h-9 w-9 items-center justify-center rounded-full border-0 bg-slate-100 p-0 text-xl leading-none text-slate-500 opacity-100 shadow-none transition [text-shadow:none] hover:bg-slate-200 hover:text-slate-700"
      aria-label="Close" (click)="onCancel()">
      <span class="block leading-none" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (type != 'FORM') {
      <div [innerHTML]="data?.content"></div>
    }
    @if (type == 'FORM') {
      <info-view [modifyData]="data?.modifyData || {}" [mode]="mode" [sourceData]="data?.sourceData" [formData]="data?.formData"></info-view>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">{{data?.btn||'Ok'}}</button>
  </div>
</div>
